// @react
import React from 'react'
// @types
import type { ReactElement } from 'react'
import type {
  GetUserQuery,
  GetUserQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @libraries
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
// @components
import Box from '@bit/atd.web.box'
import Button from '@bit/atd.web.button'
import Grid from '@bit/atd.web.grid'
import SkeletonLoader from '@bit/atd.web.loaders.skeleton'
// @constants
import { ExternalRouteNames } from 'constants/routeNames'
import strings from 'lib/constants/strings'

const useStyles = makeStyles({
  body: {
    paddingTop: '6px !important',
  },
  text: {
    '& p:not(:last-child)': {
      marginBottom: '8px',
    },
    '& + $actions': {
      marginTop: '22px',
    },
  },
  actions: {},
  btnContribute: {
    marginBottom: '16px',
  },
})

const Community = (): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()

  const { data, loading } = useQuery<GetUserQuery, GetUserQueryVariables>(
    GET_USER,
    {
      fetchPolicy: 'cache-first',
    },
  )

  /******************************************
   * RENDERS
   ******************************************/

  if (loading) {
    return <SkeletonLoader />
  }

  const user = data?.user
  const benefitsMessage_one = strings.BENEFITS.COMMUNITY.SUBTITLE_ONE
  const benefitsMessage_two = strings.BENEFITS.COMMUNITY.SUBTITLE_TWO

  return (
    <Box
      classNames={{ body: classes.body }}
      variant={'subModule'}
      header={{
        title: 'Community',
      }}
    >
      <Grid container>
        {/* Text */}
        <Grid className={classes.text} item xs={12}>
          <Typography variant="body1">{benefitsMessage_one}</Typography>
          <Typography variant="body1">{benefitsMessage_two}</Typography>
        </Grid>

        {/* Actions */}
        <Grid className={classes.actions} item xs={12}>
          {user?.isContributor && user?.visibility.publicProfile && (
            <Button
              fullWidth
              className={classes.btnContribute}
              href={ExternalRouteNames.ATD_CONTRIBUTE}
              variant="primary"
            >
              Contribute Content
            </Button>
          )}

          <Button
            fullWidth
            href="/search/blogs?query=&hierarchicalMenu%5BcontentTypes.lvl0%5D=Blog+>+Community+Content&page=1"
            variant="secondary"
          >
            View All Content
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Community
